import { Field } from "formik";
import React from "react";
import VStack from "../layout/VStack/VStack";

const TextInput = ({
  label,
  name,
  placeholder,
  errorMessage,
  required,
  type = "text",
  className = "bInput",
  disabled = false,
  isFormik = true,
  value,
  onChange,
  maxLength,
  gap = 4,
  style,
}) => {
  return (
    <VStack gap={gap}>
      <label className="tText text-sm">
        {label}
        <span style={{ color: required ? "red" : "black" }}>
          {required ? "*" : ""}
        </span>
      </label>
      {isFormik ? (
        <Field
          type={type}
          name={name}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
        />
      ) : (
        <input
          type={type}
          name={name}
          placeholder={placeholder}
          disabled={disabled}
          value={value}
          onChange={onChange}
          maxLength={maxLength}
        />
      )}
      {errorMessage && <div style={{ color: "red" }}>{errorMessage}</div>}
    </VStack>
  );
};

export default TextInput;
